export default __webpack_public_path__ + "static/media/target.baaefbe7.gif";